import { render, staticRenderFns } from "./CustomerInvoiceComparison.vue?vue&type=template&id=996727d0&scoped=true&"
import script from "./CustomerInvoiceComparison.vue?vue&type=script&lang=js&"
export * from "./CustomerInvoiceComparison.vue?vue&type=script&lang=js&"
import style0 from "./CustomerInvoiceComparison.vue?vue&type=style&index=0&id=996727d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996727d0",
  null
  
)

export default component.exports